import React from "react";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";

interface IProps {
    headerText?: string;
    iconName?: string;
}

const SectionHeader: React.FunctionComponent<IProps> = (props) => {
    return (
        <div className="box-title-container">
            <div className="box-title-icon" aria-hidden="true">
                {props.iconName === "la-tachometer-alt" ? <RenderIcons iconName="tachometer-alt" /> : <em className={`las ${props.iconName}`}></em>}
            </div>
            <div className="box-title-text">
                <h2 className="box-title"> {props.headerText}</h2>
            </div>
        </div>
    );
};

export default SectionHeader;
